module.exports = __webpack_public_path__ + "static/media/SDG13.6aa19cb6.png";